module.exports = __webpack_public_path__ + "img/faming16.f47156ac.png";